module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "sp",
    attrs: {
      "id": "ch1"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "CN"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_ch1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("Chapter One")])])]), _vm._v(" "), _c('p', {
    staticClass: "CT"
  }, [_c('span', {
    staticClass: "Homber-BT"
  }, [_vm._v("In which there may be a Vorpel.")])]), _vm._v(" "), _c('p', {
    staticClass: "COF"
  }, [_c('span', {
    staticClass: "cic"
  }, [_vm._v("“G")]), _vm._v("urgling Goblins. Venomous Vorpels. Monstrous Murgs,” Grandma Maud told Eliza. “It could have been any of them.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("They were standing in the yard behind Old Tumbledown Farm. Grandma Maud was scowling as she pointed her stick at a sweater on the clothesline. Well, it used to be a sweater. Now it was more of an oversized flannel. Both its sleeves and most of its body appeared to have been eaten overnight.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“It could have been Gertrude,” said Eliza.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Gertrude?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“That ate your sweater.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Nonsense, child!” said Grandma Maud. “That goat would never touch anything of mine. She’s far too fond of me.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Eliza stole a look at Gertrude, their goat, who was sitting nearby. Very nearby. And calmly chewing. As Eliza frowned at her, Gertrude froze.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“I’m sure it was something much more dangerous,” Grandma Maud went on. “When it returns, I daresay that will be the end of us.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Well, not if I have anything to do with it,” said Eliza.")]), _vm._v(" "), _c('p', {
    staticClass: "img-r"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "176",
      "src": "images/pg2.jpg",
      "width": "200"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("She’d been practicing with her new bow and arrow for days. Now she held up her bow, placed the arrow, pulled back the string, shut one eye, aimed at her target—a piece of parchment tacked to a nearby tree—and let the arrow fly.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("The arrow soared through the air, toward the tree, past the tree, on a bit, then climbed high into the air, before finally plunging down into the woods beyond the end of the yard. There was an unfortunate squawk.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“I wouldn’t bother with your bow and arrow, dear,” said Grandma Maud. “If a Vorpel decides to eat us, it will simply eat us.”")]), _vm._v(" "), _c('p', {
    staticClass: "img-r"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "371",
      "src": "images/pg3.jpg",
      "width": "400"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Hmmmn. If something "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("did")]), _vm._v(" come to attack the farm, Eliza didn’t want to end up as its dinner, or even its predinner snack. There were plenty of man-eating creatures in the forests of Squerb: Diabolical Dragons, Grofulous Ghouls, the Dread Vole of Gweem, the Very Surprising Caterpillar, the Even More Surprising Slice of Ham—and Eliza wasn’t going to let them get her or her family. So she spent the rest of the morning practicing with her bow and arrows. Soon the yard was dotted with arrows. There were arrows in barrows. Arrows in marrows. Arrows in the nests of worried-looking sparrows. In fact, there was only one place where there "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("weren’t")]), _vm._v(" any arrows—and that was in the target.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Meanwhile, Grandma Maud was reading aloud from one of her favorite books: "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Five Hundred Signs That the World Is About to End.")]), _vm._v(" Occasionally, she beckoned Eliza over to read out a particularly frightening entry.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Venomous Vorpels,” Grandma Maud said excitedly, “are highly dangerous creatures that will appear before The End of Time. They can be identified by their long gray tendrils—Quick!” she shrieked. “There! A Vorpel! Fire!”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Eliza looked up. Beyond the hedge at the end of the yard, there "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("was")]), _vm._v(" a long gray tendril floating in the air. She aimed, fired, and, for the first time that day, hit her target.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Unfortunately, or perhaps fortunately, her target turned out not to be a Venomous Vorpel. Or even a Vaguely Villainous Vorpel. It was just Nora, an old lady who lived in the local village, The Middle of Nowhere.")]), _vm._v(" "), _c('p', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "382",
      "src": "images/pg5.jpg",
      "width": "500"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Morning!” Nora waved cheerfully. She appeared not to have noticed the arrow that was now nestled in her hair. “Are you coming to hear the news?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Grandma, should I say something?” asked Eliza under her breath.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Not at all, that would be most impolite,” Grandma Maud murmured. “What news?” she asked more loudly.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“There’s a royal announcement happening in the village,” said Nora.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“I’ll see you there, Nora,” said Eliza.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Royal news,” said Grandma Maud, shaking her head. “It’s probably nothing important.” Then her eyes lit up. “Unless it’s The End of the World! Could well be. After all, it "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("is")]), _vm._v(" written that the world will end on a cloudy day.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Um, where is that written, Grandma?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“It is written in a notebook,” said Grandma Maud. “A notebook that I just wrote it in.”")]), _vm._v(" "), _c('p', {
    staticClass: "img-l"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "305",
      "src": "images/pg6.jpg",
      "width": "300"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Personally, Eliza didn’t really care about the royal family. It was Eliza’s sister, Lavender, who loved that sort of thing. For a moment, Eliza wondered where her sister was. For Lavender was very, very far away …")]), _vm._v(" "), _c('p', {
    staticClass: "SB-STD"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "SB1"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("At last")]), _vm._v(", Lavender thought. At last she was where she belonged. Once, she had been just a poor, humble, and incredibly talented young girl who lived with her family on a small farm in The Back of Beyond. But now, finally, Lavender was exactly where she deserved to be. She was standing in a ballroom, gazing into the eyes of her one true love.")]), _vm._v(" "), _c('p', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "536",
      "src": "images/pg7.jpg",
      "width": "500"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "TXS"
  }, [_vm._v("“Prince Magnus the Magnetic,” she whispered as they began to waltz across the ballroom. In that moment, Lavender felt as if she was floating on air. "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("He dances so elegantly")]), _vm._v(", she thought, "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("in spite of all the nails, horseshoes, and iron chains stuck to his chest and arms.")]), _vm._v(" As the dance drew to a close, Prince Magnus the Magnetic smiled, leaned toward her, and whispered:")]), _vm._v(" "), _c('p', {
    staticClass: "EXV"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("“LAVENDER?! LAVENDER! LAVENDER!!!”")])]), _vm._v(" "), _c('p', {
    staticClass: "STX"
  }, [_vm._v("Lavender looked up.")]), _vm._v(" "), _c('p', {
    staticClass: "img-r"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "400",
      "src": "images/pg8.jpg",
      "width": "167"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Suddenly, the ballroom vanished, and Lavender found herself back in the yard behind her home. Instead of the fragrance of roses, she could now smell a distinct whiff of mud. And goat. And in front of her, instead of the handsome, smiling face of Prince Magnus the Magnetic, was the frowning, intensely irritating face of her sister, Eliza.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Lavender, were you daydreaming again?” asked Eliza.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Er, no,” said Lavender.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Have you washed Gertrude yet?”")]), _vm._v(" "), _c('p', {
    staticClass: "img-r"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "347",
      "src": "images/pg9.jpg",
      "width": "275"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Er, yes,” said Lavender.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Really?” said Eliza. “Because she looked muddy this morning, and she looks even muddier now. Also, were you waltzing with her?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Er, no.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“And why is she wearing a crown?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Is she?” said Lavender. “I didn’t notice. How strange.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Eliza sighed. “Well, do you want to come and hear the Village Crier? Apparently, he has some royal news.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“ROYAL NEWS!” said Lavender. “Why didn’t you tell me?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“I just did,” said Eliza.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Well then, why are you holding us up?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“I’m not,” said Eliza.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“You are! You are holding us up with all this conversation! We should be running, not talking!”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“But you’re the one who’s talking.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“But you’re the one who started it!”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“But does that even matter?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“NO!”")]), _vm._v(" "), _c('p', {
    staticClass: "TXS"
  }, [_vm._v("Then Lavender was off, skipping all the way to the village. While she skipped, she sang. Like many of her songs, this one had many words, and no tune whatsoever.")]), _vm._v(" "), _c('p', {
    staticClass: "EXV"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("“A palace is my destiny,")])]), _vm._v(" "), _c('p', {
    staticClass: "EXV"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("That’s where my prince will wait for me.")])]), _vm._v(" "), _c('p', {
    staticClass: "EXV"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("He’ll bring me joy and scones for tea,")])]), _vm._v(" "), _c('p', {
    staticClass: "EXV"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Our happiness will spread you see,")])]), _vm._v(" "), _c('p', {
    staticClass: "EXV"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Just like jam—or leprosy")])]), _vm._v(" "), _c('p', {
    staticClass: "EXV"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("(But it won’t be quite so itchy).")])]), _vm._v(" "), _c('p', {
    staticClass: "EXV"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("And we will sing in harmony")])]), _vm._v(" "), _c('p', {
    staticClass: "EXV"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("In a perfect key")])]), _vm._v(" "), _c('p', {
    staticClass: "EXV"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("(That’s not rusty).")])]), _vm._v(" "), _c('p', {
    staticClass: "EXV"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("The key of eeeeeeeeeeeeeeee")])]), _vm._v(" "), _c('p', {
    staticClass: "EXV"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("eeeeeeeeeeeeeeeeeee")])]), _vm._v(" "), _c('p', {
    staticClass: "EXV"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("eeeeeeeeeeeeeeeeeeeeee")])]), _vm._v(" "), _c('p', {
    staticClass: "EXV"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("eeeeeeeeeeeeeeeeeeeeeeeee!")])]), _vm._v(" "), _c('p', {
    staticClass: "EXV"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Because a palace is my destiny.”")])]), _vm._v(" "), _c('p', {
    staticClass: "STX"
  }, [_vm._v("As Lavender skipped and sang and villagers fled from her, shaking their heads and clutching their ears, Eliza ran along beside her, smiling contentedly. She loved it when her sister sang, because it made her feel proud. Proud of her latest invention: gobbets of candle wax that she put in her ears so she couldn’t hear a single note of Lavender’s hideous singing.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-229e5985","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter1.vue
// module id = 69
// module chunks = 0